// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"TermsAndConditions_privacyPolicy__wlZNm"};